import request from '@/utils/request'

export const feature = () => {
  return request({
    url: '/user/feature'
  })
}

// 获取章节模块
export const chapter = () => {
  return request({
    url: '/user/chapter'
  })
}


// 获取站点配置信息
export const siteConfig = (params) => {
  return request({
    url: '/system_configs/site_config',
    params
  })
}

//更新站点配置信息
export const editConfig = (data, locale) => {
  return request({
    url: `/system_configs/site_config?locale=${locale}`,
    method: 'PUT',
    data
  })
}

//栏目信息列表
export const columnList = () => {
  return request({
    url: `/pages`,
    method: 'get',
  })
}


//栏目信息列表
export const industryNews = (data) => {
  return request({
    url: `/pages/${data.eng_name}`,
    method: 'PUT',
    data
  })
}


//轮播图列表
export const banNers = (params) => {
  return request({
    url: `/banners`,
    method: 'get',
    params
  })
}


//轮播图新增
export const addbanNers = (data) => {
  return request({
    url: `/banners`,
    method: 'POST',
    data
  })
}

//轮播图编辑
export const editbanNers = (data) => {
  return request({
    url: `/banners/${data.id}`,
    method: 'PUT',
    data
  })
}



//轮播图删除
export const delbanNers = (data) => {
  return request({
    url: `/banners/${data.id}`,
    method: 'DELETE',
    data
  })
}